import { createContext, useContext, useState } from "react";

const translations = {
  fr: {
    nav: {
      links: [
        { href: "#accueil", label: "Accueil", testid: "nav-accueil-link" },
        { href: "#a-propos", label: "À Propos", testid: "nav-about-link" },
        { href: "#services", label: "Services", testid: "nav-services-link" },
        { href: "#pourquoi", label: "Pourquoi Nous", testid: "nav-why-link" },
        { href: "#simulateur", label: "Simulateur", testid: "nav-simulator-link" },
        { href: "#contact", label: "Contact", testid: "nav-contact-link" },
      ],
      cta: "Prendre Rendez-vous",
    },
    hero: {
      eyebrow: "Revenue Management Hôtelier — Hôtels Indépendants",
      title1: "Maximisez la rentabilité de votre ",
      titleAccent: "établissement hôtelier",
      sub: "Experte senior passionnée de revenue management et d'automatisation, j'accompagne depuis plus de 18 ans les hôtels indépendants, en France et à l'international : tarification dynamique et distribution maîtrisée.",
      cta1: "Prendre Rendez-vous",
      cta2: "Découvrir mes Services",
      kpis: [
        { value: "18+", label: "Années d'expérience hôtelière" },
        { value: "4", label: "Langues de négociation" },
        { value: "+18%", label: "RevPAR moyen constaté*" },
        { value: "+32%", label: "Performance commerciale*" },
      ],
      note: "* Indicateurs types observés sur les accompagnements revenue management.",
      ribbon: ["Revenue Management", "Tarification Dynamique", "Stratégie Tarifaire", "Distribution", "Automatisation", "Yield Management", "Audit de Performance", "Formation d'Équipes"],
      imgAlt: "Baie des Anges et Promenade des Anglais à Nice",
    },
    about: {
      eyebrow: "À Propos",
      role: "Fondatrice — EBS Hotels Revenue · ABC Consulting 22",
      bio1: "Basée à Nice, je mets plus de 18 ans d'expertise en revenue management au service des hôtels indépendants, en France et à l'international. Diplômée d'un Master en Gestion et Aménagement Touristique et Hôtelier (Nice), je conjugue rigueur analytique, connaissance intime des marchés hôteliers — saisonniers, événementiels et clientèle internationale — et maîtrise des outils d'automatisation les plus avancés (RMS, PMS, Channel Manager).",
      bio2a: "Le revenue management n'est pas seulement mon métier : c'est ma ",
      bio2b: " depuis plus de 18 ans.",
      passion: "passion",
      langLabel: "Négociation fluide avec les clientèles et partenaires internationaux",
      languages: [
        { code: "FR", name: "Français" },
        { code: "EN", name: "Anglais" },
        { code: "IT", name: "Italien" },
        { code: "BG", name: "Bulgare" },
      ],
      quote: "Un prix juste, au bon moment, sur le bon canal : c'est toute la différence entre un hôtel qui subit sa saison et un hôtel qui la pilote.",
      badge: "Ans d'excellence",
      imgAlt: "Valeria Dragneva — Consultante senior en revenue management hôtelier",
    },
    services: {
      eyebrow: "Services & Pôles d'Expertise",
      title1: "Une ingénierie du revenu ",
      titleAccent: "sur-mesure",
      sub: "De l'audit initial à l'automatisation complète de votre stratégie tarifaire, chaque accompagnement est conçu pour défendre votre prix moyen et votre marge nette.",
      items: [
        { title: "Revenue Management Stratégique & Opérationnel", description: "Pilotage quotidien et hebdomadaire des grilles tarifaires, inventaires, durées de séjour et anticipation de la demande saisonnière propre à votre marché.", tag: "Cœur de métier", testid: "service-card-revenue-management" },
        { title: "Tarification Dynamique & Yield Algorithmique", description: "Modélisation en temps réel selon les événements majeurs de votre destination — festivals, congrès, manifestations sportives — et la pression concurrentielle.", tag: "Performance", testid: "service-card-pricing-dynamique" },
        { title: "Distribution & Désintermédiation OTA", description: "Reprise de contrôle sur Booking.com et Expedia, optimisation du site direct, parité tarifaire et réduction durable des commissions de distribution.", tag: "Rentabilité", testid: "service-card-distribution-ota" },
        { title: "Automatisation & Connectivité Tech", description: "Paramétrage expert de vos outils (RMS, PMS, Channel Manager : Mews, Cloudbeds, D-Edge, IDeaS, Duetto…) pour supprimer les tâches chronophages et fiabiliser la donnée.", tag: "Technologie", testid: "service-card-automatisation" },
        { title: "Audit de Performance & Potentiel Inexploité", description: "Diagnostic complet à 360° : historique RevPAR, segmentation clients, rythme de réservation, benchmark concurrentiel et plan d'action d'accélération immédiat.", tag: "Diagnostic", testid: "service-card-audit" },
        { title: "Formation des Équipes & Culture du Revenue", description: "Acculturation des chefs de réception, équipes réservation et directions générales aux réflexes du yield management de haute volée.", tag: "Transmission", testid: "service-card-formation" },
      ],
    },
    whyme: {
      eyebrow: "Pourquoi me choisir",
      title1: "L'expertise d'un revenue manager senior, ",
      titleAccent: "sans en supporter le coût",
      intro: "Plutôt que d'embaucher un revenue manager — bien trop coûteux en interne pour la plupart des hôtels indépendants — choisissez la formule partenaire : une experte senior à vos côtés, sans engagement, avec des honoraires adaptés à votre chiffre d'affaires.",
      cards: [
        { title: "Moins cher qu'un salarié", description: "Recruter un revenue manager expérimenté en CDI représente un coût très lourd pour un hôtel indépendant. Avec EBS, vous accédez à une expertise senior à la carte, uniquement quand vous en avez besoin.", testid: "why-me-card-cost" },
        { title: "Une formule partenaire, sans engagement", description: "Pas de contrat verrouillé : devenez mon partenaire et avançons ensemble à votre rythme, avec la liberté d'ajuster ou d'interrompre la collaboration à tout moment.", testid: "why-me-card-flexible" },
        { title: "Des prix adaptés à votre chiffre d'affaires", description: "La tarification de mes services est proportionnée à la taille et au chiffre d'affaires de votre établissement : un modèle équitable, pensé pour les hôtels indépendants.", testid: "why-me-card-pricing" },
        { title: "Une passionnée à vos côtés", description: "Le revenue management n'est pas seulement mon métier : c'est ma passion depuis plus de 18 ans. Chaque hôtel accompagné bénéficie d'un engagement personnel et total.", testid: "why-me-card-passion" },
      ],
      cta: "Discutons de votre établissement",
      remoteLine: "Je travaille entièrement à distance : peu importe où se trouve votre hôtel en Europe, je suis à vos côtés.",
    },
    refs: {
      eyebrow: "Références & Parcours",
      title1: "Une expertise ",
      titleAccent: "éprouvée sur le terrain",
      sub: "18 ans au service de l'hôtellerie, des postes opérationnels à la direction d'hébergement.",
      entries: [
        { role: "Directrice d'hébergement", company: "Goldstar Resort & Suites — Nice", period: "Depuis 2016", desc: "Direction de l'hébergement : analyse financière et opérationnelle, veille des tendances du marché et planification stratégique.", testid: "reference-entry-0" },
        { role: "Revenue Manager", company: "Goldstar Resort & Suites — Nice", period: "2009 – 2016", desc: "Positionnement stratégique du marché, analyse par segments, bases de données statistiques et tarification dynamique face à la concurrence.", testid: "reference-entry-1" },
        { role: "Directrice Ventes & Opérations", company: "Teranga & Savoy Hotels — Juan-les-Pins", period: "2007 – 2009", desc: "Yield management, stratégies tarifaires et développement des ventes.", testid: "reference-entry-2" },
      ],
      testimonialsLabel: "Témoignages",
      sampleBadge: "Exemple — à personnaliser",
      testimonials: [
        { quote: "« Le témoignage de votre client viendra ici : son établissement, le défi rencontré et le résultat obtenu ensemble. »", author: "— Direction d'hôtel partenaire", testid: "testimonial-card-0" },
        { quote: "« Le témoignage de votre client viendra ici : son établissement, le défi rencontré et le résultat obtenu ensemble. »", author: "— Direction d'hôtel partenaire", testid: "testimonial-card-1" },
      ],
    },
    simulator: {
      eyebrow: "Simulateur de Potentiel",
      title1: "Estimez le gain de ",
      titleAccent: "votre hôtel",
      desc: "Indiquez les caractéristiques de votre établissement et visualisez l'impact annuel estimé d'un pilotage revenue management professionnel (scénario prudent : +12% de RevPAR).",
      sliders: [
        { label: "Nombre de chambres", testid: "simulator-rooms-input" },
        { label: "Taux d'occupation actuel", testid: "simulator-occupancy-input" },
        { label: "Prix moyen (ADR)", testid: "simulator-adr-input" },
      ],
      currentLabel: "Revenu chambres annuel actuel",
      projectedLabel: "Revenu projeté avec EBS Hotels Revenue",
      gainLabel: "Gain annuel estimé",
      disclaimer: "Estimation indicative fondée sur un scénario prudent. Un audit personnalisé permet d'établir une projection précise selon votre marché et votre segmentation.",
      cta: "Demander mon audit personnalisé",
    },
    booking: {
      eyebrow: "Prise de Rendez-vous",
      title1: "Réservez votre ",
      titleAccent: "échange découverte",
      desc: "Choisissez directement un créneau : je vous confirme le rendez-vous personnellement par email ou téléphone sous 24h ouvrées.",
      nameLabel: "Nom complet *",
      namePlaceholder: "Votre nom",
      emailLabel: "Email *",
      phoneLabel: "Téléphone",
      dateLabel: "Date souhaitée *",
      timeLabel: "Créneau horaire *",
      messageLabel: "Message (optionnel)",
      messagePlaceholder: "Dites-moi en quelques mots l'objet de l'échange…",
      submit: "Réserver ce créneau",
      loading: "Réservation en cours…",
      note: "Sans engagement — un simple échange pour faire connaissance.",
      toastOk: "Demande de rendez-vous envoyée",
      toastOkDesc: "Je vous confirme le créneau personnellement sous 24h ouvrées.",
      toastErr: "L'envoi a échoué",
      toastErrDesc: "Merci de réessayer ou d'appeler le +33 6 62 80 56 12.",
    },
    contact: {
      eyebrow: "Contact",
      title1: "Un échange direct, ",
      titleAccent: "en toute confidentialité",
      sub: "Propriétaire ou directeur d'hôtel indépendant, en France ou à l'international ? Échangeons sur le potentiel inexploité de votre établissement. Discrétion professionnelle absolue : contactez-moi directement par email, téléphone ou via les réseaux.",
      infoTitle: "Coordonnées directes",
      infoLabels: { email: "Email", phone: "Téléphone", location: "Localisation", facebook: "Facebook", instagram: "Instagram" },
      location: "Nice — interventions France & International",
      engagements: ["Réponse personnelle sous 24–48h ouvrées", "Formule partenaire sans engagement", "Honoraires adaptés à votre chiffre d'affaires", "Échanges possibles en FR · EN · IT · BG"],
      engagementsTitle: "Engagements",
    },
    footer: {
      tagline: "Excellence et ingénierie du revenue management hôtelier, au service des hôtels indépendants. Marque exploitée par ABC Consulting 22 — Nice.",
      facebook: "EBS Hotels Revenue sur Facebook",
      location: "Basée à Nice — France & International",
      copyright: "© 2026 EBS HOTELS REVENUE — ABC Consulting 22. Tous droits réservés.",
      ethics: "Déontologie hôtelière · Discrétion professionnelle · Nice",
    },
  },
  en: {
    nav: {
      links: [
        { href: "#accueil", label: "Home", testid: "nav-accueil-link" },
        { href: "#a-propos", label: "About", testid: "nav-about-link" },
        { href: "#services", label: "Services", testid: "nav-services-link" },
        { href: "#pourquoi", label: "Why Me", testid: "nav-why-link" },
        { href: "#simulateur", label: "Simulator", testid: "nav-simulator-link" },
        { href: "#contact", label: "Contact", testid: "nav-contact-link" },
      ],
      cta: "Book a Call",
    },
    hero: {
      eyebrow: "Hotel Revenue Management — Independent Hotels",
      title1: "Maximize the profitability of your ",
      titleAccent: "hotel property",
      sub: "A senior expert passionate about revenue management and automation, I have been supporting independent hotels in France and internationally for over 18 years: dynamic pricing and controlled distribution.",
      cta1: "Book a Call",
      cta2: "Discover my Services",
      kpis: [
        { value: "18+", label: "Years of hotel experience" },
        { value: "4", label: "Negotiation languages" },
        { value: "+18%", label: "Average RevPAR observed*" },
        { value: "+32%", label: "Commercial performance*" },
      ],
      note: "* Typical indicators observed across revenue management engagements.",
      ribbon: ["Revenue Management", "Dynamic Pricing", "Pricing Strategy", "Distribution", "Automation", "Yield Management", "Performance Audit", "Team Training"],
      imgAlt: "Bay of Angels and Promenade des Anglais in Nice",
    },
    about: {
      eyebrow: "About",
      role: "Founder — EBS Hotels Revenue · ABC Consulting 22",
      bio1: "Based in Nice, I bring over 18 years of revenue management expertise to independent hotels, in France and internationally. A graduate of the Master's in Tourism and Hotel Management and Development (Nice), I combine analytical rigor, intimate knowledge of hotel markets — seasonal, event-driven and international clientele — and mastery of the most advanced automation tools (RMS, PMS, Channel Manager).",
      bio2a: "Revenue management is not just my job: it has been my ",
      bio2b: " for over 18 years.",
      passion: "passion",
      langLabel: "Fluent negotiation with international guests and partners",
      languages: [
        { code: "FR", name: "French" },
        { code: "EN", name: "English" },
        { code: "IT", name: "Italian" },
        { code: "BG", name: "Bulgarian" },
      ],
      quote: "The right price, at the right time, on the right channel: that is the difference between a hotel that endures its season and one that commands it.",
      badge: "Years of excellence",
      imgAlt: "Valeria Dragneva — Senior hotel revenue management consultant",
    },
    services: {
      eyebrow: "Services & Areas of Expertise",
      title1: "Revenue engineering ",
      titleAccent: "tailored to you",
      sub: "From the initial audit to full automation of your pricing strategy, every engagement is designed to defend your average daily rate and your net margin.",
      items: [
        { title: "Strategic & Operational Revenue Management", description: "Daily and weekly management of pricing grids, inventories, lengths of stay and anticipation of the seasonal demand specific to your market.", tag: "Core expertise", testid: "service-card-revenue-management" },
        { title: "Dynamic Pricing & Algorithmic Yield", description: "Real-time modelling based on your destination's major events — festivals, conferences, sporting events — and competitive pressure.", tag: "Performance", testid: "service-card-pricing-dynamique" },
        { title: "Distribution & OTA Disintermediation", description: "Take back control from Booking.com and Expedia, optimize your direct website, rate parity and achieve a lasting reduction of distribution commissions.", tag: "Profitability", testid: "service-card-distribution-ota" },
        { title: "Automation & Tech Connectivity", description: "Expert configuration of your tools (RMS, PMS, Channel Manager: Mews, Cloudbeds, D-Edge, IDeaS, Duetto…) to remove time-consuming tasks and make your data reliable.", tag: "Technology", testid: "service-card-automatisation" },
        { title: "Performance Audit & Untapped Potential", description: "A full 360° diagnosis: RevPAR history, customer segmentation, booking pace, competitive benchmark and an immediate acceleration action plan.", tag: "Diagnosis", testid: "service-card-audit" },
        { title: "Team Training & Revenue Culture", description: "Instilling front-desk managers, reservation teams and general managers with the reflexes of high-level yield management.", tag: "Knowledge transfer", testid: "service-card-formation" },
      ],
    },
    whyme: {
      eyebrow: "Why choose me",
      title1: "Senior revenue manager expertise, ",
      titleAccent: "without the overhead",
      intro: "Instead of hiring a revenue manager — far too costly in-house for most independent hotels — choose the partner formula: a senior expert by your side, with no commitment, and fees tailored to your revenue.",
      cards: [
        { title: "More affordable than an employee", description: "Hiring an experienced revenue manager on a permanent contract is a heavy cost for an independent hotel. With EBS, you access senior expertise on demand, only when you need it.", testid: "why-me-card-cost" },
        { title: "A partner formula, no strings attached", description: "No locked-in contract: become my partner and let's move forward at your pace, free to adjust or end the collaboration at any time.", testid: "why-me-card-flexible" },
        { title: "Fees tailored to your revenue", description: "My service fees are proportionate to your property's size and turnover: a fair model designed for independent hotels.", testid: "why-me-card-pricing" },
        { title: "A passionate expert by your side", description: "Revenue management is not just my job: it has been my passion for over 18 years. Every hotel I support receives my full personal commitment.", testid: "why-me-card-passion" },
      ],
      cta: "Let's discuss your property",
      remoteLine: "I work fully remotely: wherever your hotel is located in Europe, I am by your side.",
    },
    refs: {
      eyebrow: "References & Track Record",
      title1: "Field-proven ",
      titleAccent: "expertise",
      sub: "18 years serving hospitality, from operational roles to accommodation management.",
      entries: [
        { role: "Hotel Operations Manager", company: "Goldstar Resort & Suites — Nice", period: "Since 2016", desc: "Accommodation management: financial and operational analysis, market trend monitoring and strategic planning.", testid: "reference-entry-0" },
        { role: "Revenue Manager", company: "Goldstar Resort & Suites — Nice", period: "2009 – 2016", desc: "Strategic market positioning, segment analysis, statistical databases and dynamic pricing against competitors.", testid: "reference-entry-1" },
        { role: "Sales & Operations Director", company: "Teranga & Savoy Hotels — Juan-les-Pins", period: "2007 – 2009", desc: "Yield management, pricing strategies and sales development.", testid: "reference-entry-2" },
      ],
      testimonialsLabel: "Testimonials",
      sampleBadge: "Sample — to be personalized",
      testimonials: [
        { quote: "« Your client's testimonial will appear here: their property, the challenge, and the result achieved together. »", author: "— Partner hotel management", testid: "testimonial-card-0" },
        { quote: "« Your client's testimonial will appear here: their property, the challenge, and the result achieved together. »", author: "— Partner hotel management", testid: "testimonial-card-1" },
      ],
    },
    simulator: {
      eyebrow: "Potential Simulator",
      title1: "Estimate the gain for ",
      titleAccent: "your hotel",
      desc: "Enter your property's characteristics and see the estimated annual impact of professional revenue management (conservative scenario: +12% RevPAR).",
      sliders: [
        { label: "Number of rooms", testid: "simulator-rooms-input" },
        { label: "Current occupancy rate", testid: "simulator-occupancy-input" },
        { label: "Average daily rate (ADR)", testid: "simulator-adr-input" },
      ],
      currentLabel: "Current annual room revenue",
      projectedLabel: "Projected revenue with EBS Hotels Revenue",
      gainLabel: "Estimated annual gain",
      disclaimer: "Indicative estimate based on a conservative scenario. A personalized audit provides an accurate projection for your market and segmentation.",
      cta: "Request my personalized audit",
    },
    booking: {
      eyebrow: "Book a Call",
      title1: "Book your ",
      titleAccent: "discovery call",
      desc: "Pick a slot directly: I will personally confirm the appointment by email or phone within 24 business hours.",
      nameLabel: "Full name *",
      namePlaceholder: "Your name",
      emailLabel: "Email *",
      phoneLabel: "Phone",
      dateLabel: "Preferred date *",
      timeLabel: "Time slot *",
      messageLabel: "Message (optional)",
      messagePlaceholder: "In a few words, what would you like to discuss…",
      submit: "Book this slot",
      loading: "Booking…",
      note: "No commitment — a simple conversation to get to know each other.",
      toastOk: "Appointment request sent",
      toastOkDesc: "I will personally confirm the slot within 24 business hours.",
      toastErr: "Sending failed",
      toastErrDesc: "Please try again or call +33 6 62 80 56 12.",
    },
    contact: {
      eyebrow: "Contact",
      title1: "A direct conversation, ",
      titleAccent: "in complete confidence",
      sub: "Owner or manager of an independent hotel, in France or abroad? Let's talk about your property's untapped potential. Absolute professional discretion: contact me directly by email, phone or social media.",
      infoTitle: "Direct contact details",
      infoLabels: { email: "Email", phone: "Phone", location: "Location", facebook: "Facebook", instagram: "Instagram" },
      location: "Nice — France & International",
      engagements: ["Personal reply within 24–48 business hours", "Partner formula, no commitment", "Fees tailored to your revenue", "Conversations possible in FR · EN · IT · BG"],
      engagementsTitle: "Commitments",
    },
    footer: {
      tagline: "Excellence and engineering of hotel revenue management, serving independent hotels. A brand operated by ABC Consulting 22 — Nice.",
      facebook: "EBS Hotels Revenue on Facebook",
      location: "Based in Nice — France & International",
      copyright: "© 2026 EBS HOTELS REVENUE — ABC Consulting 22. All rights reserved.",
      ethics: "Hotel ethics · Professional discretion · Nice",
    },
  },
  it: {
    nav: {
      links: [
        { href: "#accueil", label: "Home", testid: "nav-accueil-link" },
        { href: "#a-propos", label: "Chi Sono", testid: "nav-about-link" },
        { href: "#services", label: "Servizi", testid: "nav-services-link" },
        { href: "#pourquoi", label: "Perché Io", testid: "nav-why-link" },
        { href: "#simulateur", label: "Simulatore", testid: "nav-simulator-link" },
        { href: "#contact", label: "Contatti", testid: "nav-contact-link" },
      ],
      cta: "Prenota un Appuntamento",
    },
    hero: {
      eyebrow: "Revenue Management Alberghiero — Hotel Indipendenti",
      title1: "Massimizza la redditività del tuo ",
      titleAccent: "hotel",
      sub: "Esperta senior appassionata di revenue management e automazione, accompagno da oltre 18 anni gli hotel indipendenti, in Francia e a livello internazionale: prezzi dinamici e distribuzione controllata.",
      cta1: "Prenota un Appuntamento",
      cta2: "Scopri i miei Servizi",
      kpis: [
        { value: "18+", label: "Anni di esperienza alberghiera" },
        { value: "4", label: "Lingue di negoziazione" },
        { value: "+18%", label: "RevPAR medio constatato*" },
        { value: "+32%", label: "Performance commerciale*" },
      ],
      note: "* Indicatori tipici osservati negli accompagnamenti di revenue management.",
      ribbon: ["Revenue Management", "Prezzi Dinamici", "Strategia Tariffaria", "Distribuzione", "Automazione", "Yield Management", "Audit di Performance", "Formazione del Team"],
      imgAlt: "Baia degli Angeli e Promenade des Anglais a Nizza",
    },
    about: {
      eyebrow: "Chi Sono",
      role: "Fondatrice — EBS Hotels Revenue · ABC Consulting 22",
      bio1: "Con base a Nizza, metto oltre 18 anni di esperienza nel revenue management al servizio degli hotel indipendenti, in Francia e a livello internazionale. Laureata con un Master in Gestione e Sviluppo Turistico e Alberghiero (Nizza), unisco rigore analitico, conoscenza intima dei mercati alberghieri — stagionali, eventi e clientela internazionale — e padronanza degli strumenti di automazione più avanzati (RMS, PMS, Channel Manager).",
      bio2a: "Il revenue management non è solo il mio lavoro: è la mia ",
      bio2b: " da oltre 18 anni.",
      passion: "passione",
      langLabel: "Negoziazione fluente con clientela e partner internazionali",
      languages: [
        { code: "FR", name: "Francese" },
        { code: "EN", name: "Inglese" },
        { code: "IT", name: "Italiano" },
        { code: "BG", name: "Bulgaro" },
      ],
      quote: "Il prezzo giusto, al momento giusto, sul canale giusto: è tutta la differenza tra un hotel che subisce la sua stagione e uno che la gestisce.",
      badge: "Anni di eccellenza",
      imgAlt: "Valeria Dragneva — Consulente senior di revenue management alberghiero",
    },
    services: {
      eyebrow: "Servizi & Aree di Competenza",
      title1: "Un'ingegneria del ricavo ",
      titleAccent: "su misura",
      sub: "Dall'audit iniziale all'automazione completa della tua strategia tariffaria, ogni accompagnamento è pensato per difendere il tuo prezzo medio e il tuo margine netto.",
      items: [
        { title: "Revenue Management Strategico & Operativo", description: "Gestione quotidiana e settimanale delle griglie tariffarie, inventari, durate del soggiorno e anticipazione della domanda stagionale propria del tuo mercato.", tag: "Cuore del mestiere", testid: "service-card-revenue-management" },
        { title: "Prezzi Dinamici & Yield Algoritmico", description: "Modellazione in tempo reale secondo i grandi eventi della tua destinazione — festival, congressi, manifestazioni sportive — e la pressione concorrenziale.", tag: "Performance", testid: "service-card-pricing-dynamique" },
        { title: "Distribuzione & Disintermediazione OTA", description: "Riprendi il controllo su Booking.com ed Expedia, ottimizzazione del sito diretto, parità tariffaria e riduzione duratura delle commissioni di distribuzione.", tag: "Redditività", testid: "service-card-distribution-ota" },
        { title: "Automazione & Connettività Tech", description: "Configurazione esperta dei tuoi strumenti (RMS, PMS, Channel Manager: Mews, Cloudbeds, D-Edge, IDeaS, Duetto…) per eliminare le attività ripetitive e rendere affidabili i dati.", tag: "Tecnologia", testid: "service-card-automatisation" },
        { title: "Audit di Performance & Potenziale Inespresso", description: "Diagnosi completa a 360°: storico RevPAR, segmentazione clienti, ritmo di prenotazione, benchmark concorrenziale e piano d'azione di accelerazione immediata.", tag: "Diagnosi", testid: "service-card-audit" },
        { title: "Formazione dei Team & Cultura del Revenue", description: "Trasmettere ai capi ricevimento, ai team prenotazioni e alle direzioni generali i riflessi dello yield management di alto livello.", tag: "Trasmissione", testid: "service-card-formation" },
      ],
    },
    whyme: {
      eyebrow: "Perché scegliermi",
      title1: "L'esperienza di un revenue manager senior, ",
      titleAccent: "senza sostenerne il costo",
      intro: "Invece di assumere un revenue manager — troppo costoso internamente per la maggior parte degli hotel indipendenti — scegli la formula partner: un'esperta senior al tuo fianco, senza impegno, con onorari adeguati al tuo fatturato.",
      remoteLine: "Lavoro interamente a distanza: ovunque si trovi il tuo hotel in Europa, sono al tuo fianco.",
      cards: [
        { title: "Più economico di un dipendente", description: "Assumere un revenue manager esperto a tempo indeterminato rappresenta un costo molto pesante per un hotel indipendente. Con EBS accedi a un'expertise senior alla carta, solo quando ne hai bisogno.", testid: "why-me-card-cost" },
        { title: "Una formula partner, senza impegno", description: "Nessun contratto vincolante: diventa mio partner e avanziamo insieme al tuo ritmo, con la libertà di adattare o interrompere la collaborazione in qualsiasi momento.", testid: "why-me-card-flexible" },
        { title: "Prezzi adattati al tuo fatturato", description: "La tariffazione dei miei servizi è proporzionata alle dimensioni e al fatturato della tua struttura: un modello equo, pensato per gli hotel indipendenti.", testid: "why-me-card-pricing" },
        { title: "Un'appassionata al tuo fianco", description: "Il revenue management non è solo il mio lavoro: è la mia passione da oltre 18 anni. Ogni hotel accompagnato beneficia di un impegno personale e totale.", testid: "why-me-card-passion" },
      ],
      cta: "Parliamo della tua struttura",
    },
    refs: {
      eyebrow: "Referenze & Percorso",
      title1: "Un'esperienza ",
      titleAccent: "provata sul campo",
      sub: "18 anni al servizio dell'ospitalità, dai ruoli operativi alla direzione.",
      entries: [
        { role: "Direttrice delle operazioni alberghiere", company: "Goldstar Resort & Suites — Nizza", period: "Dal 2016", desc: "Direzione delle operazioni: analisi finanziaria e operativa, monitoraggio delle tendenze di mercato e pianificazione strategica.", testid: "reference-entry-0" },
        { role: "Revenue Manager", company: "Goldstar Resort & Suites — Nizza", period: "2009 – 2016", desc: "Posizionamento strategico di mercato, analisi per segmenti, database statistici e prezzi dinamici rispetto alla concorrenza.", testid: "reference-entry-1" },
        { role: "Direttrice Vendite & Operazioni", company: "Teranga & Savoy Hotels — Juan-les-Pins", period: "2007 – 2009", desc: "Yield management, strategie tariffarie e sviluppo delle vendite.", testid: "reference-entry-2" },
      ],
      testimonialsLabel: "Testimonianze",
      sampleBadge: "Esempio — da personalizzare",
      testimonials: [
        { quote: "« Qui apparirà la testimonianza del tuo cliente: la sua struttura, la sfida e il risultato ottenuto insieme. »", author: "— Direzione di hotel partner", testid: "testimonial-card-0" },
        { quote: "« Qui apparirà la testimonianza del tuo cliente: la sua struttura, la sfida e il risultato ottenuto insieme. »", author: "— Direzione di hotel partner", testid: "testimonial-card-1" },
      ],
    },
    simulator: {
      eyebrow: "Simulatore di Potenziale",
      title1: "Stima il guadagno del ",
      titleAccent: "tuo hotel",
      desc: "Indica le caratteristiche della tua struttura e visualizza l'impatto annuale stimato di una gestione professionale del revenue management (scenario prudente: +12% di RevPAR).",
      sliders: [
        { label: "Numero di camere", testid: "simulator-rooms-input" },
        { label: "Tasso di occupazione attuale", testid: "simulator-occupancy-input" },
        { label: "Prezzo medio (ADR)", testid: "simulator-adr-input" },
      ],
      currentLabel: "Ricavo camere annuale attuale",
      projectedLabel: "Ricavo previsto con EBS Hotels Revenue",
      gainLabel: "Guadagno annuale stimato",
      disclaimer: "Stima indicativa basata su uno scenario prudente. Un audit personalizzato permette di stabilire una proiezione precisa secondo il tuo mercato e la tua segmentazione.",
      cta: "Richiedi il mio audit personalizzato",
    },
    booking: {
      eyebrow: "Prenota un Appuntamento",
      title1: "Prenota la tua ",
      titleAccent: "chiamata conoscitiva",
      desc: "Scegli direttamente una fascia oraria: ti confermo personalmente l'appuntamento via email o telefono entro 24 ore lavorative.",
      nameLabel: "Nome completo *",
      namePlaceholder: "Il tuo nome",
      emailLabel: "Email *",
      phoneLabel: "Telefono",
      dateLabel: "Data preferita *",
      timeLabel: "Fascia oraria *",
      messageLabel: "Messaggio (opzionale)",
      messagePlaceholder: "Dimmi in poche parole l'oggetto della conversazione…",
      submit: "Prenota questa fascia",
      loading: "Prenotazione in corso…",
      note: "Senza impegno — una semplice conversazione per conoscerci.",
      toastOk: "Richiesta di appuntamento inviata",
      toastOkDesc: "Ti confermo personalmente la fascia entro 24 ore lavorative.",
      toastErr: "Invio fallito",
      toastErrDesc: "Riprova o chiama il +33 6 62 80 56 12.",
    },
    contact: {
      eyebrow: "Contatti",
      title1: "Un confronto diretto, ",
      titleAccent: "in piena riservatezza",
      sub: "Proprietario o direttore di un hotel indipendente, in Francia o all'estero? Parliamo del potenziale inespresso della tua struttura. Assoluta discrezione professionale: contattami direttamente via email, telefono o sui social.",
      infoTitle: "Contatti diretti",
      infoLabels: { email: "Email", phone: "Telefono", location: "Localizzazione", facebook: "Facebook", instagram: "Instagram" },
      location: "Nizza — interventi in Francia e all'Estero",
      engagements: ["Risposta personale entro 24–48 ore lavorative", "Formula partner senza impegno", "Onorari adeguati al tuo fatturato", "Conversazioni possibili in FR · EN · IT · BG"],
      engagementsTitle: "Impegni",
    },
    footer: {
      tagline: "Eccellenza e ingegneria del revenue management alberghiero, al servizio degli hotel indipendenti. Marchio gestito da ABC Consulting 22 — Nizza.",
      facebook: "EBS Hotels Revenue su Facebook",
      location: "Con base a Nizza — Francia & Internazionale",
      copyright: "© 2026 EBS HOTELS REVENUE — ABC Consulting 22. Tutti i diritti riservati.",
      ethics: "Deontologia alberghiera · Discrezione professionale · Nizza",
    },
  },
  bg: {
    nav: {
      links: [
        { href: "#accueil", label: "Начало", testid: "nav-accueil-link" },
        { href: "#a-propos", label: "За мен", testid: "nav-about-link" },
        { href: "#services", label: "Услуги", testid: "nav-services-link" },
        { href: "#pourquoi", label: "Защо аз", testid: "nav-why-link" },
        { href: "#simulateur", label: "Симулатор", testid: "nav-simulator-link" },
        { href: "#contact", label: "Контакти", testid: "nav-contact-link" },
      ],
      cta: "Запазете час",
    },
    hero: {
      eyebrow: "Хотелски Revenue Management — Независими хотели",
      title1: "Максимизирайте рентабилността на вашия ",
      titleAccent: "хотел",
      sub: "Старши експерт, страстно отдадена на revenue management и автоматизация, подкрепям независимите хотели във Франция и по целия свят повече от 18 години: динамично ценообразуване и контролирана дистрибуция.",
      cta1: "Запазете час",
      cta2: "Разгледайте моите услуги",
      kpis: [
        { value: "18+", label: "Години хотелски опит" },
        { value: "4", label: "Езика на преговори" },
        { value: "+18%", label: "Среден RevPAR*" },
        { value: "+32%", label: "Търговски резултати*" },
      ],
      note: "* Типични показатели, наблюдавани при съпровождания по revenue management.",
      ribbon: ["Revenue Management", "Динамично ценообразуване", "Ценова стратегия", "Дистрибуция", "Автоматизация", "Yield Management", "Одит на резултатите", "Обучение на екипи"],
      imgAlt: "Валерия Драгнева — консултант по revenue management",
    },
    about: {
      eyebrow: "За мен",
      role: "Основател — EBS Hotels Revenue · ABC Consulting 22",
      bio1: "С база в Ница, влагам повече от 18 години експертиза в revenue management в услуга на независимите хотели във Франция и по света. Завършила съм магистратура по туристически и хотелски мениджмънт и развитие (Ница) и съчетавам аналитична точност, задълбочено познаване на хотелските пазари — сезонни, събития и международна клиентела — и владеене на най-модерните инструменти за автоматизация (RMS, PMS, Channel Manager).",
      bio2a: "Revenue management не е просто моята работа: това е моята ",
      bio2b: " повече от 18 години.",
      passion: "страст",
      langLabel: "Свободни преговори с международни клиенти и партньори",
      languages: [
        { code: "FR", name: "Френски" },
        { code: "EN", name: "Английски" },
        { code: "IT", name: "Италиански" },
        { code: "BG", name: "Български" },
      ],
      quote: "Точната цена, в точния момент, по точния канал: това е разликата между хотел, който търпи сезона си, и хотел, който го управлява.",
      badge: "Години съвършенство",
      imgAlt: "Валерия Драгнева — Старши консултант по хотелски revenue management",
    },
    services: {
      eyebrow: "Услуги и области на експертиза",
      title1: "Инженеринг на приходите ",
      titleAccent: "по мярка",
      sub: "От първоначалния одит до пълната автоматизация на вашата ценова стратегия — всяко сътрудничество е насочено към защита на средната ви цена и нетния ви марж.",
      items: [
        { title: "Стратегически и оперативен Revenue Management", description: "Ежедневно и седмично управление на ценовите таблици, наличности, продължителност на престоя и предвиждане на сезонното търсене, характерно за вашия пазар.", tag: "Основна експертиза", testid: "service-card-revenue-management" },
        { title: "Динамично ценообразуване и алгоритмичен Yield", description: "Моделиране в реално време според големите събития на вашата дестинация — фестивали, конгреси, спортни прояви — и конкурентния натиск.", tag: "Резултатност", testid: "service-card-pricing-dynamique" },
        { title: "Дистрибуция и деинтермедиация на OTA", description: "Възвърнете контрола над Booking.com и Expedia, оптимизация на директния сайт, ценова паритетност и трайно намаляване на дистрибуционните комисионни.", tag: "Рентабилност", testid: "service-card-distribution-ota" },
        { title: "Автоматизация и технологична свързаност", description: "Експертна настройка на вашите инструменти (RMS, PMS, Channel Manager: Mews, Cloudbeds, D-Edge, IDeaS, Duetto…) за премахване на отнемащите време задачи и надеждни данни.", tag: "Технологии", testid: "service-card-automatisation" },
        { title: "Одит на резултатите и неизползван потенциал", description: "Пълна 360° диагностика: история на RevPAR, клиентска сегментация, ритъм на резервации, конкурентен бенчмарк и план за незабавно ускоряване.", tag: "Диагностика", testid: "service-card-audit" },
        { title: "Обучение на екипи и култура на Revenue", description: "Запознаване на ръководителите на рецепция, екипите по резервации и генералните мениджъри с рефлексите на yield management от висок клас.", tag: "Предаване", testid: "service-card-formation" },
      ],
    },
    whyme: {
      eyebrow: "Защо да ме изберете",
      title1: "Експертиза на старши revenue manager, ",
      titleAccent: "без високата цена",
      intro: "Вместо да наемате revenue manager — твърде скъпо за повечето независими хотели — изберете партньорската формула: старши експерт до вас, без ангажимент, с хонорари, съобразени с вашия оборот.",
      remoteLine: "Работя изцяло дистанционно: където и да се намира вашият хотел в Европа, аз съм до вас.",
      cards: [
        { title: "По-изгодно от служител", description: "Назначаването на опитен revenue manager на постоянен договор е тежък разход за независим хотел. С EBS получавате старши експертиза по заявка, само когато имате нужда.", testid: "why-me-card-cost" },
        { title: "Партньорска формула, без ангажимент", description: "Без обвързващ договор: станете мой партньор и вървим заедно с ваше темпо, със свободата да промените или прекратите сътрудничеството по всяко време.", testid: "why-me-card-flexible" },
        { title: "Цени, съобразени с вашия оборот", description: "Ценообразуването на моите услуги е съразмерно с размера и оборота на вашия хотел: справедлив модел, създаден за независими хотели.", testid: "why-me-card-pricing" },
        { title: "Страстен експерт до вас", description: "Revenue management не е просто моята работа: това е моята страст повече от 18 години. Всеки хотел, който подкрепям, получава пълната ми лична отдаденост.", testid: "why-me-card-passion" },
      ],
      cta: "Нека обсъдим вашия хотел",
    },
    refs: {
      eyebrow: "Референции и опит",
      title1: "Експертиза, ",
      titleAccent: "доказана на практика",
      sub: "18 години в услуга на хотелиерството — от оперативни роли до управление.",
      entries: [
        { role: "Директор хотелски операции", company: "Goldstar Resort & Suites — Ница", period: "От 2016", desc: "Управление на хотелското обслужване: финансов и оперативен анализ, следене на пазарните тенденции и стратегическо планиране.", testid: "reference-entry-0" },
        { role: "Revenue Manager", company: "Goldstar Resort & Suites — Ница", period: "2009 – 2016", desc: "Стратегическо пазарно позициониране, сегментен анализ, статистически бази данни и динамично ценообразуване спрямо конкуренцията.", testid: "reference-entry-1" },
        { role: "Директор продажби и операции", company: "Teranga & Savoy Hotels — Juan-les-Pins", period: "2007 – 2009", desc: "Yield management, ценови стратегии и развитие на продажбите.", testid: "reference-entry-2" },
      ],
      testimonialsLabel: "Отзиви",
      sampleBadge: "Пример — за персонализиране",
      testimonials: [
        { quote: "« Тук ще бъде отзивът на вашия клиент: хотелът му, предизвикателството и постигнатият резултат. »", author: "— Управление на хотел партньор", testid: "testimonial-card-0" },
        { quote: "« Тук ще бъде отзивът на вашия клиент: хотелът му, предизвикателството и постигнатият резултат. »", author: "— Управление на хотел партньор", testid: "testimonial-card-1" },
      ],
    },
    simulator: {
      eyebrow: "Симулатор на потенциала",
      title1: "Изчислете печалбата на ",
      titleAccent: "вашия хотел",
      desc: "Въведете характеристиките на вашия хотел и вижте прогнозния годишен ефект от професионално управление на приходите (предпазлив сценарий: +12% RevPAR).",
      sliders: [
        { label: "Брой стаи", testid: "simulator-rooms-input" },
        { label: "Текуща заетост", testid: "simulator-occupancy-input" },
        { label: "Средна цена (ADR)", testid: "simulator-adr-input" },
      ],
      currentLabel: "Текущи годишни приходи от стаи",
      projectedLabel: "Прогнозни приходи с EBS Hotels Revenue",
      gainLabel: "Прогнозна годишна печалба",
      disclaimer: "Ориентировъчна оценка, базирана на предпазлив сценарий. Персонализираният одит дава точна прогноза според вашия пазар и сегментация.",
      cta: "Заявете моя персонализиран одит",
    },
    booking: {
      eyebrow: "Запазете час",
      title1: "Запазете вашия ",
      titleAccent: "запознавателен разговор",
      desc: "Изберете директно час: ще потвърдя лично срещата по имейл или телефон в рамките на 24 работни часа.",
      nameLabel: "Име и фамилия *",
      namePlaceholder: "Вашето име",
      emailLabel: "Email *",
      phoneLabel: "Телефон",
      dateLabel: "Предпочитана дата *",
      timeLabel: "Часови диапазон *",
      messageLabel: "Съобщение (по избор)",
      messagePlaceholder: "Кажете ми накратко какво бихте искали да обсъдим…",
      submit: "Запазете този час",
      loading: "Запазване…",
      note: "Без ангажимент — просто разговор за запознаване.",
      toastOk: "Заявката за среща е изпратена",
      toastOkDesc: "Ще потвърдя лично часа в рамките на 24 работни часа.",
      toastErr: "Изпращането е неуспешно",
      toastErrDesc: "Моля, опитайте отново или се обадете на +33 6 62 80 56 12.",
    },
    contact: {
      eyebrow: "Контакти",
      title1: "Директен разговор, ",
      titleAccent: "в пълна поверителност",
      sub: "Собственик или директор на независим хотел, във Франция или в чужбина? Нека поговорим за неизползвания потенциал на вашия хотел. Абсолютна професионална дискретност: свържете се директно с мен по имейл, телефон или чрез социалните мрежи.",
      infoTitle: "Директни контакти",
      infoLabels: { email: "Email", phone: "Телефон", location: "Локация", facebook: "Facebook", instagram: "Instagram" },
      location: "Ница — Франция и международно",
      engagements: ["Личен отговор в рамките на 24–48 работни часа", "Партньорска формула без ангажимент", "Хонорари, съобразени с вашия оборот", "Разговори възможни на FR · EN · IT · BG"],
      engagementsTitle: "Ангажименти",
    },
    footer: {
      tagline: "Съвършенство и инженеринг на хотелския revenue management в услуга на независимите хотели. Марка, управлявана от ABC Consulting 22 — Ница.",
      facebook: "EBS Hotels Revenue във Facebook",
      location: "С база в Ница — Франция и международно",
      copyright: "© 2026 EBS HOTELS REVENUE — ABC Consulting 22. Всички права запазени.",
      ethics: "Хотелска етика · Професионална дискретност · Ница",
    },
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("ebs-lang") || "fr");
  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("ebs-lang", l);
    document.documentElement.lang = l;
  };
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
